import React, { useEffect, useState } from 'react';
import moment from 'moment';
import FlagIcon from './icons/FlagIcon.jsx';
import { TriangleBlueIcon } from './icons/TriangleBlueIcon.jsx';

const MilestoneCard = ({ mile }) => {
  const { name, notes, date_at } = mile;
  const [isShowMore, setIsShowMore] = useState(false);
  const [isShowMoreBtnNeed, setIsShowMoreBtnNeed] = useState(false);

  useEffect(() => {
    const viewNote = document.getElementById(name);
    if (viewNote && viewNote.scrollHeight > viewNote.clientHeight) {
      setIsShowMoreBtnNeed(true);
    }
  }, []);

  return (
    <div className="milestone-card">
      <h4 className="flex m-b-16">
        <div
          className="flex header-item bordered m-r-8"
          style={{ borderColor: mile.project_id ? '#27B0E0' : '#5771CA' }}
        >
          <FlagIcon fill={mile.project_id ? '#27B0E0' : '#5771CA'} />
        </div>
        {name}
      </h4>

      <h6 className="m-b-16">{moment(date_at).format('MM/DD/YYYY')}</h6>

      <div className="m-b-16">
        {notes?.length ? (
          <div id={name} className={`text-muted ${!isShowMore && 'notes'}`}>
            {notes}
          </div>
        ) : null}
        {isShowMoreBtnNeed ? (
          <button
            type="button"
            className="btn-clear bg-transparent btn-link"
            onClick={() => setIsShowMore(!isShowMore)}
            style={{ paddingLeft: 0 }}
          >
            {!isShowMore ? (
              <span className="flex flex-align-center">
                <span className="m-r-8">Show More</span>
                <TriangleBlueIcon
                  style={{ height: '20px' }}
                  transform="rotate(180)"
                />
              </span>
            ) : (
              <span className="flex flex-align-center">
                <span className="m-r-8">Hide</span>
                <TriangleBlueIcon style={{ height: '20px' }} />
              </span>
            )}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default MilestoneCard;
